import { useTranslation } from "react-i18next";

import { Flex } from "../../../../../components/Flex";
import { AtiraEmpty } from "../../../../../components/AtiraEmpty";
import { Info } from "../../../../../components/Info";
import { FontSize, Text } from "../../../../../components/Text";
import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { EntityIcons } from "../../../../../utils/GlobalIcons";
import { useAppSelector } from "../../../../../redux/store";
import { reportSliceSelectors } from "../../../../../redux/report/report.selector";
import { ActivityEntityKind } from "../../../../../model/activity/types/ActivityEntityKind.enum";
import { ReportTrendChart } from "../../ReportTrendChart";
import styled from "styled-components";
import { Spacing } from "../../../../../theme/Spacing";

const Title = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${Spacing.s};
  font-weight: bold;
  font-size: ${FontSize.l};
  color: ${({ theme }) => theme.main};

  svg {
    width: 2.5rem;
  }
`;

export const ReportsSummaryModuleTab: React.FC = () => {
  const { t } = useTranslation();

  const reports = useAppSelector(reportSliceSelectors.selectReport);

  // Module activity already flows through the report; it just had nowhere to
  // be shown. There is no module count to total, so the per-day activity and
  // the per-member drawer are what there is to say about it.
  const total = (reports.trend || []).reduce(
    (sum, point) => sum + (point[ActivityEntityKind.MODULE] || 0),
    0,
  );

  return (
    <Flex flexDirection="column" gap="s">
      <Title>
        <AtiraIcon icon={EntityIcons.Modules} />
        {t("common.modules")}
      </Title>

      <Flex flexDirection="column" gap="l">
        <Info info={t("reports.modules.info")} />

        {total ? (
          <Flex flexDirection="column" gap="xs">
            <Text fontWeight="bold">{t("reports.module.title")}</Text>
            <Text fontSize="xl">{total}</Text>
            <ReportTrendChart kind={ActivityEntityKind.MODULE} />
          </Flex>
        ) : (
          <AtiraEmpty description={t("common.empty")} />
        )}
      </Flex>
    </Flex>
  );
};
